import { useState, useEffect } from 'react';
import { Crown, Dumbbell, TrendingDown, TrendingUp, Flame, Trophy } from 'lucide-react';
import { apiClient } from '../../contexts/AuthContext';
import { UserAvatar } from '../UserAvatar';

const CATEGORIES = [
  { key: 'presences', label: 'Presences', icon: Dumbbell, color: '#FF6B35', emptyMsg: 'Pas de donnees de presence cette semaine' },
  { key: 'muscle', label: 'Prise muscle', icon: TrendingUp, color: '#3b82f6', emptyMsg: 'Pas de nouvelles mesures cette semaine' },
  { key: 'gras', label: 'Perte gras', icon: TrendingDown, color: '#2e7d32', emptyMsg: 'Pas de nouvelles mesures cette semaine' },
  { key: 'defis', label: 'Defis realises', icon: Flame, color: '#FFB800', emptyMsg: 'Aucun defi complete cette semaine' },
];

export function TopSemaineCard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    apiClient.get('/top-semaine').then(r => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;

  return (
    <div className="bg-[#1B1B1B] border border-[#2A2A2E] rounded-lg p-4" data-testid="top-semaine">
      <h2 className="text-xl text-white mb-3" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
        <Crown className="w-5 h-5 text-[#FFB800] inline mr-1.5 mb-0.5" /> Top de la semaine
      </h2>

      <div className="grid grid-cols-2 gap-3">
        {CATEGORIES.map(({ key, label, icon: Icon, color, emptyMsg }) => {
          const entries = data[key];
          return (
            <div key={key} className="bg-[#0F0F0F] rounded-lg p-3 border border-[#2A2A2E]" data-testid={`top-${key}`}>
              <div className="flex items-center gap-1.5 mb-2">
                <Icon className="w-3.5 h-3.5" style={{ color }} />
                <span className="text-[10px] font-bold uppercase tracking-wider" style={{ color }}>{label}</span>
              </div>
              {!entries ? (
                <p className="text-[9px] text-zinc-600 italic">{emptyMsg}</p>
              ) : (
                <div className="space-y-1.5">
                  {entries.slice(0, 3).map((e, i) => (
                    <div key={e.user_id} className="flex items-center gap-2">
                      <span className={`text-[9px] font-black w-4 ${i === 0 ? 'text-[#FFB800]' : 'text-zinc-600'}`}>
                        {i === 0 ? <Trophy className="w-3 h-3 text-[#FFB800]" /> : `${i+1}`}
                      </span>
                      <UserAvatar name={e.name} photoPath={e.photo} size="xs" />
                      <span className="text-xs text-white truncate flex-1">{e.name}</span>
                      <span className="font-mono text-[10px] font-bold" style={{ color }}>
                        {e.value}{e.unit}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
